(function(){
 'use strict';
 if(window.__csHanfuCollectionNav) return;
 window.__csHanfuCollectionNav=true;
 function init(root){
  if(root.dataset.hfBound==='true') return;
  root.dataset.hfBound='true';
  var button=root.querySelector('[data-hf-toggle]');
  var menu=root.querySelector('[data-hf-menu]');
  var track=root.querySelector('[data-hf-track]');
  var arrows=Array.from(root.querySelectorAll('[data-hf-scroll]'));
  var links=Array.from(menu.querySelectorAll('a'));
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  var usePopover=typeof menu.showPopover==='function';
  var opened=false;
  var resizeObserver;
  var controller=new AbortController();
  var signal=controller.signal;
  function listen(el,event,callback,opts){el.addEventListener(event,callback,Object.assign({signal:signal},opts||{}));}
  function positionMenu(){
   var rect=button.getBoundingClientRect();
   var gap=14, width=Math.min(340,window.innerWidth-gap*2);
   var rtl=getComputedStyle(root).direction==='rtl';
   var left=rtl?rect.right-width:rect.left;
   var top=Math.max(gap,Math.min(rect.bottom+8,window.innerHeight-180));
   menu.style.width=width+'px';
   menu.style.left=Math.max(gap,Math.min(left,window.innerWidth-width-gap))+'px';
   menu.style.top=top+'px';
   menu.style.maxHeight=Math.max(120,window.innerHeight-top-gap)+'px';
  }
  function closeMenu(restore){
   if(!opened) return;
   if(usePopover&&menu.matches(':popover-open')) menu.hidePopover();
   menu.hidden=true;opened=false;button.setAttribute('aria-expanded','false');
   if(restore) button.focus({preventScroll:true});
  }
  function openMenu(focusAt){
   positionMenu();menu.hidden=false;
   if(usePopover&&!menu.matches(':popover-open')) menu.showPopover();
   opened=true;button.setAttribute('aria-expanded','true');
   if(focusAt==='last') links[links.length-1].focus({preventScroll:true});
   if(focusAt==='first') (menu.querySelector('[aria-current=page]')||links[0]).focus({preventScroll:true});
  }
  listen(button,'click',function(){opened?closeMenu(false):openMenu('first');});
  listen(button,'keydown',function(e){if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();openMenu(e.key==='ArrowUp'?'last':'first');}});
  listen(menu,'keydown',function(e){
   if(e.key==='Escape'){e.preventDefault();e.stopPropagation();closeMenu(true);return;}
   var index=links.indexOf(document.activeElement), next;
   if(e.key==='ArrowDown') next=(index+1)%links.length;
   if(e.key==='ArrowUp') next=(index-1+links.length)%links.length;
   if(e.key==='Home') next=0;
   if(e.key==='End') next=links.length-1;
   if(next!==undefined){e.preventDefault();links[next].focus();}
  });
  listen(menu,'click',function(e){if(e.target.closest('a')) closeMenu(false);});
  listen(document,'click',function(e){if(opened&&!menu.contains(e.target)&&!button.contains(e.target)) closeMenu(false);});
  listen(document,'focusin',function(e){if(opened&&!menu.contains(e.target)&&!button.contains(e.target)) closeMenu(false);});
  listen(document,'keydown',function(e){if(opened&&e.key==='Escape'){e.preventDefault();closeMenu(true);}});
  listen(root.querySelector('[data-cs-lvfilter-open]'),'click',function(){closeMenu(false);});
  function updateArrows(){
   var items=track.querySelectorAll('.cs-hf__category');
   var bounds=track.getBoundingClientRect();
   var first=items[0].getBoundingClientRect(),last=items[items.length-1].getBoundingClientRect();
   var overflow=track.scrollWidth>track.clientWidth+2;
   var clippedLeft=Math.min(first.left,last.left)<bounds.left-2;
   var clippedRight=Math.max(first.right,last.right)>bounds.right+2;
   arrows.forEach(function(a){a.hidden=!overflow;a.disabled=a.dataset.hfScroll==='-1'?!clippedLeft:!clippedRight;});
  }
  function centerActive(){
   var active=track.querySelector('[aria-current=page]');
   if(active&&track.scrollWidth>track.clientWidth+2){
    var r=active.getBoundingClientRect(),p=track.getBoundingClientRect();
    track.scrollBy({left:(r.left+r.right-p.left-p.right)/2,behavior:'instant'});
   }
   updateArrows();
  }
  arrows.forEach(function(a){listen(a,'click',function(){track.scrollBy({left:Number(a.dataset.hfScroll)*Math.max(220,track.clientWidth*.65),behavior:reduced.matches?'instant':'smooth'});});});
  listen(track,'scroll',updateArrows,{passive:true});
  listen(track,'focusin',function(e){var a=e.target.closest('.cs-hf__category');if(a){var r=a.getBoundingClientRect(),p=track.getBoundingClientRect();if(r.left<p.left||r.right>p.right)track.scrollBy({left:(r.left+r.right-p.left-p.right)/2,behavior:'instant'});}});
  listen(window,'resize',function(){if(opened) positionMenu();updateArrows();},{passive:true});
  listen(window,'scroll',function(){if(opened) positionMenu();},{passive:true});
  if(window.ResizeObserver){resizeObserver=new ResizeObserver(updateArrows);resizeObserver.observe(track);}
  requestAnimationFrame(centerActive);
  listen(document,'shopify:section:unload',function(e){if(e.target.contains(root)){closeMenu(false);controller.abort();if(resizeObserver)resizeObserver.disconnect();}});
 }
 function boot(){document.querySelectorAll('[data-cs-hanfu-nav]').forEach(init);}
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
})();
